/* tslint:disable */
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackAuth } from '../core/auth.service';
import { LoopBackFilter,  } from '../../models/BaseModels';
import { ErrorHandler } from '../core/error.service';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { GamePlayerEmoji } from '../../models/GamePlayerEmoji';
import { SocketConnection } from '../../sockets/socket.connections';
import { Emoji } from '../../models/Emoji';
import { GamePlayer } from '../../models/GamePlayer';


/**
 * Api services for the `GamePlayerEmoji` model.
 */
@Injectable()
export class GamePlayerEmojiApi extends BaseLoopBackApi {

  constructor(
    @Inject(HttpClient) protected http: HttpClient,
    @Inject(SocketConnection) protected connection: SocketConnection,
    @Inject(SDKModels) protected models: SDKModels,
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    @Optional() @Inject(ErrorHandler) protected errorHandler: ErrorHandler
  ) {
    super(http,  connection,  models, auth, errorHandler);
  }

  /**
   * Fetches belongsTo relation emoji.
   *
   * @param {any} id GamePlayerEmoji id
   *
   * @param {boolean} refresh 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `GamePlayerEmoji` object.)
   * </em>
   */
  public getEmoji(id: any, refresh: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/game-player-emojis/:id/emoji";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof refresh !== 'undefined' && refresh !== null) _urlParams.refresh = refresh;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * Fetches belongsTo relation player.
   *
   * @param {any} id GamePlayerEmoji id
   *
   * @param {boolean} refresh 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `GamePlayerEmoji` object.)
   * </em>
   */
  public getPlayer(id: any, refresh: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/game-player-emojis/:id/player";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof refresh !== 'undefined' && refresh !== null) _urlParams.refresh = refresh;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * Patch an existing model instance or insert a new one into the data source.
   *
   * @param {object} data Request data.
   *
   *  - `data` – `{object}` - Model instance data
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `GamePlayerEmoji` object.)
   * </em>
   */
  public patchOrCreate(data: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "PATCH";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/game-player-emojis";
    let _routeParams: any = {};
    let _postBody: any = {
      data: data
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * Patch attributes for a model instance and persist it into the data source.
   *
   * @param {any} id GamePlayerEmoji id
   *
   * @param {object} data Request data.
   *
   *  - `data` – `{object}` - An object of model property name/value pairs
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `GamePlayerEmoji` object.)
   * </em>
   */
  public patchAttributes(id: any, data: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "PATCH";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/game-player-emojis/:id";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {
      data: data
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * return selected game player emojis.
   *
   * @param {object} data Request data.
   *
   *  - `gameId` – `{string}` - Game Id.
   *
   *  - `playerId` – `{string}` - Player Id.
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * selected game player emojis.
   */
  public selectedGamePlayerEmojis(gameId: any, playerId: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/game-player-emojis/selected-game-player-emojis";
    let _routeParams: any = {};
    let _postBody: any = {
      data: {
        gameId: gameId,
        playerId: playerId
      }
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * create or update game player emojis
   *
   * @param {object} data Request data.
   *
   *  - `gameId` – `{string}` - Game Id.
   *
   *  - `playerId` – `{string}` - Player Id.
   *
   *  - `playerEmojis` – `{any}` - selected game player emojis.
   *
   *  - `isAutoMatch` – `{boolean}` - true when the entry was made by AutoMatch (JUNE27 p43). MUST stay declared: without it strong-remoting passes its callback into this positional slot, which is truthy.
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * This method returns no data.
   */
  public upsertGamePlayerEmojis(gameId: any, playerId: any, playerEmojis: any, isAutoMatch: any = {}, customHeaders?: Function): Observable<GamePlayerEmoji> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/game-player-emojis/upsert-game-player-emojis";
    let _routeParams: any = {};
    let _postBody: any = {
      data: {
        gameId: gameId,
        playerId: playerId,
        playerEmojis: playerEmojis,
        isAutoMatch: isAutoMatch
      }
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result.pipe(map((instance: GamePlayerEmoji) => new GamePlayerEmoji(instance)));
  }

  /**
   * pick and submit game player emojis
   *
   * @param {object} data Request data.
   *
   *  - `gameId` – `{string}` - Game Id.
   *
   *  - `playerId` – `{string}` - Player Id.
   *
   * @returns {object[]} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * selected game player emojis.
   */
  public pickAndSubmitGamePlayerEmojis(gameId: any, playerId: any, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/game-player-emojis/pick-and-submit-game-player-emojis";
    let _routeParams: any = {};
    let _postBody: any = {
      data: {
        gameId: gameId,
        playerId: playerId
      }
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `GamePlayerEmoji`.
   */
  public getModelName() {
    return "GamePlayerEmoji";
  }
}
